export default __webpack_public_path__ + "static/media/wolf-icon.7f1f5f89.svg";